import {Platform, StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  listContainer: {
    marginLeft: Platform.OS === 'web' ? 20 : 0,
    marginBottom: 10,
    width: Platform.OS === 'web' ? 'auto' : '100%',
  },
  listItem: {
    flexDirection: 'row',
    marginVertical: 5,
  },
  itemNumber: {
    marginRight: 5,
    fontSize: 16,
  },
  itemText: {
    fontSize: 16,
  },
});
